import { Component, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import {MatLegacyPaginator as MatPaginator} from '@angular/material/legacy-paginator';
import { EnvService } from '../services/env.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { debounceTime, Subscription } from 'rxjs';
import { CmdbClustersFilter } from './cmdb-clusters.filter';
import { SettingsPersistenceService } from '../services/settings-persistence.service';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'micro-cmdb-clusters',
  templateUrl: './cmdb-clusters.component.html',
})
export class CmdbClustersComponent {
  dataSource = new MatTableDataSource<any>();

  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  pageSettings!: SettingsPersistenceService;
  filter = new CmdbClustersFilter(this.auth);
  platformNames = new Map<string, string>();
  selectedPlatform: any;
  private subscriptions = new Subscription();
  private loadSubscription?: Subscription;

  constructor(public auth: AuthService, private env: EnvService, private http: HttpClient) {
  }

  ngOnInit(): void {
    // Setup the settings persistence service for this page
    this.pageSettings = new SettingsPersistenceService(sessionStorage, 'micro.cmdbClusters');
    this.pageSettings
      .setFilter(this.filter)
      .setPaginator(this.paginator)
      .init();

    // Subscribe to filter changes with a debounce time to avoid excessive reloads
    this.subscriptions.add(this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.paginator.pageIndex = 0;
      this.reload();
    }));

    if (this.filter.platformId) {
      this.subscriptions.add(this.http.get(`${this.env.e.url}/domain/cmdbHostingPlatform/${this.filter.platformId}`)
        .subscribe(data => this.selectedPlatform = data));
    }

    // Initial data load
    this.reload();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.loadSubscription?.unsubscribe();
    this.pageSettings.removeFilterListener();
    this.pageSettings.removePaginatorListener();
  }

  reload(): void {
    const params: HttpParams = this.filter.getParams()
      .set('page', String(this.paginator.pageIndex || 0))
      .set('size', String(this.paginator.pageSize || 20));

    this.loadSubscription?.unsubscribe();
    this.loadSubscription = this.http.get(`${this.env.e.url}/domain/cmdbClusters`, {params}).subscribe(data => {
      const page = data as any;
      this.dataSource.data = page.content;
      this.paginator.pageIndex = page.number;
      this.paginator.pageSize = page.size;
      this.paginator.length = page.totalElements;
      for (const cluster of page.content) {
        if (cluster.platformId && !this.platformNames.has(cluster.platformId)) {
          this.platformNames.set(cluster.platformId, cluster.platformId);
          this.subscriptions.add(this.http.get(`${this.env.e.url}/domain/cmdbHostingPlatform/${cluster.platformId}`)
            .subscribe((platform: any) => {
              this.platformNames.set(cluster.platformId, platform?.name || cluster.platformId);
            }));
        }
      }
    });
  }
}
